import React from 'react';
import './Footer.css';

import twitterIcon from '../assets/social/header-twitter.svg';
import discordIcon from '../assets/social/header-discord.svg';
import telegramIcon from '../assets/social/header-telegram.svg';
import instagramIcon from '../assets/social/Instagram.webp';
import mediumIcon from '../assets/social/Medium.webp';
import facebookIcon from '../assets/social/Facebook.webp';

function Footer() {
  return (
    <footer className="footer-wood">
      <div className="footer-content">
        <div className="footer-left">
          <p>© 2025 Ranchers Land. All rights reserved.</p>
        </div>

        <div className="footer-center">
          <a href="/">Home</a>
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
          <a href="mailto:ranchersland@gmail.com">Contact</a>
          <a href="/play">Play</a>
        </div>

        <div className="footer-right">
          <a href="https://twitter.com/ranchersland" target="_blank" rel="noopener noreferrer">
            <img src={twitterIcon} alt="Twitter" />
          </a>
          <a href="https://discord.gg/Rqsr8YpQuh" target="_blank" rel="noopener noreferrer">
            <img src={discordIcon} alt="Discord" />
          </a>
          <a href="https://t.me/ranchersland" target="_blank" rel="noopener noreferrer">
            <img src={telegramIcon} alt="Telegram" />
          </a>
          <a href="https://www.instagram.com/ranchers.land/" target="_blank" rel="noopener noreferrer">
            <img src={instagramIcon} alt="Instagram" />
          </a>
          <a href="https://medium.com/@ranchersland" target="_blank" rel="noopener noreferrer">
            <img src={mediumIcon} alt="Medium" />
          </a>
          <a href="https://web.facebook.com/ranchers.land/" target="_blank" rel="noopener noreferrer">
            <img src={facebookIcon} alt="Facebook" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
